<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required" />

        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center items-center pt-8 md:pt-12">
                <label class="radio block relative font-bold text-2xl lg:text-3xl cursor-pointer mb-6 sm:mb-12 md:mb-16 pl-6"
                       :class="[ value ? 'text-primary-100' : 'text-muted-500' ]">
                    <input v-model="value"
                           type="radio"
                           name="boolean"
                           :value="true"
                           class="opacity-0">
                    <span class="block w-5 md:w-6 h-5 md:h-6 absolute top-0 bottom-0 left-0 m-auto select-none text-center rounded-full bg-light-100"></span>
                    {{ yes | trans }}
                </label>

                <label class="radio block relative font-bold text-2xl lg:text-3xl cursor-pointer pl-6"
                       :class="[ value === false ? 'text-primary-100' : 'text-muted-500' ]">
                    <input v-model="value"
                           type="radio"
                           name="boolean"
                           :value="false"
                           class="opacity-0">
                    <span class="block w-5 md:w-6 h-5 md:h-6 absolute top-0 bottom-0 left-0 m-auto select-none text-center rounded-full bg-light-100"></span>
                    {{ no | trans }}
                </label>
            </div>

            <div v-if="errorMessage" class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionHeader from './QuestionHeader';

    export default {
        components: {
            QuestionHeader
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: Array
        },
        data() {
            return {
                value: null,
                yes: {
                    en: 'Yes',
                    es: 'Si'
                },
                no: {
                    en: 'No',
                    es: 'No'
                },
                errorMessage: null,
            }
        },
        watch: {
            value(data) {
                this.$emit('input', [{
                    index: data ? 0 : 1,
                    value: data
                }]);
            }
        },
        methods: {
            validate() {
                if (this.required && this.value === null) {
                    this.errorMessage =  "This field is required!";
                    return false;
                }

                this.errorMessage = null;
                return true;
            }
        },
        mounted() {
            if (this.answer[0]) {
                this.value = this.answer[0].value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .radio {
        input {
            &:checked ~ span:after {
                position: absolute;
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                border-radius: 50%;
                background: white;
                border: 6px solid #56c38c;
            }
        }
    }
</style>
